@use 'src/styles/config.module' as *;

.wrap {
  position: relative;
  overflow: hidden;
  display: flex;
  flex: 1 auto;
  z-index: 1;
  background: #f5f6f7;
}
.content {
  flex: 1 1 auto;
}
